import { isEmpty } from 'lodash'
import { EVENTS } from '~/common/constants'
import { action, computed, event, observable, store } from '~/common/mobx.decorator'
import { authStore } from '~/stores'

@store()
class NotifyStore {
	@observable messages = []
	@observable doneMessages = {}

	@observable dialogs = []
	@observable doneDialogs = {}
	@observable isOpenNotification = false
	@computed
	get waitMessages() {
		return this.messages.filter((message) => !this.doneMessages[message.key])
	}

	@computed
	get waitDialogs() {
		return this.dialogs.filter((dialog) => !this.doneDialogs[dialog.key])
	}

	@computed
	get signal() {
		return window.OneSignal || []
	}

	@action
	open = async (message, options) => {
		const data = {
			key: `${Date.now()}_${Math.random()}`,
			message,
			options,
		}

		if (options.showDialog) {
			this.dialogs.push(data)

			return data.key
		}
		if (options?.onlyWebPush) {
			return
		}

		this.messages.push(data)
		return data.key
	}

	@action
	success = async (message, options) => {
		return this.open(message, { ...options, variant: 'success' })
	}

	@action
	error = async (message, options) => {
		return this.open(message, { ...options, variant: 'error', icon: 'error' })
	}

	@action
	info = async (message, options) => {
		return this.open(message, { ...options, variant: 'info' })
	}

	@action
	warning = async (message, options) => {
		return this.open(message, { ...options, variant: 'warning' })
	}

	@action
	closeMessage = async (key) => {
		this.doneMessages[key] = true
	}

	@action
	closeDialog = async (key) => {
		this.doneDialogs[key] = true
	}

	@event(EVENTS.notifyStore.fireError)
	handleError({ payload }) {
		this.error(payload?.message)
	}

	@action
	initOneSignal = async () => {
		if (!isEmpty(process.env.REACT_APP_COMPANY_ID)) {
			this.signal.push(() => {
				this.signal.SERVICE_WORKER_PARAM = { scope: '/push/onesignal/' }
				this.signal.SERVICE_WORKER_PATH = '/push/onesignal/OneSignalSDKWorker.js'
				this.signal.SERVICE_WORKER_UPDATER_PATH = '/push/onesignal/OneSignalSDKUpdaterWorker.js'

				this.signal.init({
					appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
					autoRegister: false,
					autoResubscribe: true,
					notifyButton: {
						enable: true,
						prenotify: false,
					},
					allowLocalhostAsSecureOrigin: true,
					serviceWorkerParam: { scope: '/push/onesignal/' },
					serviceWorkerPath: '/push/onesignal/OneSignalSDKWorker.js',
				})
			})
		}
	}

	@action
	sendInfo = async () => {
		const { profile } = authStore
		if (!isEmpty(process.env.REACT_APP_ONESIGNAL_APP_ID)) {
			this.signal.addListenerForNotificationOpened((payload) => {
				this.isOpenNotification = true
				console.log('Notification opened:', payload)
			})
		}

		if (!isEmpty(process.env.REACT_APP_ONESIGNAL_APP_ID)) {
			this.signal.getSubscription((notOptedOut) => {
				if (notOptedOut) {
					this.signal.setSubscription(true)
					setTimeout(() => {
						this.signal.registerForPushNotifications()
					}, 15000)
				}
			})
			this.signal
				.sendTags({
					worker: profile?.id || '',
				})
				.then((tagsSent) => {
					console.warn('tagsSent: ', tagsSent)
				})
		}
	}

	@action
	unInitOneSignal = async () => {
		await this.signal.deleteTag('worker')
	}
}

export const notifyStore = new NotifyStore()
